class Keystore {
    constructor() {
        this.storage = window.localStorage;
    }

    getKey(key) {
        const storedValue = this.storage.getItem(key);

        if (storedValue !== null) {
            return JSON.parse(storedValue);
        } else {
            return null;
        }
    }

    getKeyOrDefault(key, defaultValue = null) {
        const storedValue = this.storage.getItem(key);

        if (storedValue !== null) {
            return JSON.parse(storedValue);
        } else {
            this.setKey(key, defaultValue);
            return defaultValue;
        }
    }

    setKey(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
    }
}

export const keystore = new Keystore();
